<script setup>
import { computed } from 'vue';
import { cva } from 'class-variance-authority';

/**
 * The page column. Every section of a page uses the same one, so content
 * lines up with the header's logo and buttons at every width.
 */
const props = defineProps({
  as: { type: String, default: 'div' },
  size: { type: String, default: 'page' },
});

const container = cva('w-full mx-auto px-4 sm:px-6', {
  variants: {
    size: {
      page: 'max-w-7xl',
      narrow: 'max-w-3xl',
    },
  },
});

const classes = computed(() => container({ size: props.size }));
</script>

<template>
  <component :is="as" :class="classes">
    <slot />
  </component>
</template>
